import { render, staticRenderFns } from "./UnboxingDetail.vue?vue&type=template&id=fda3433c&scoped=true&"
import script from "./UnboxingDetail.vue?vue&type=script&lang=js&"
export * from "./UnboxingDetail.vue?vue&type=script&lang=js&"
import style0 from "./UnboxingDetail.vue?vue&type=style&index=0&id=fda3433c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda3433c",
  null
  
)

export default component.exports